

<div id="scrn-table">
  <div id="scrn-cell">
    <div id="scrn-p">
      <header id="scrn-h">
        <div class="myunichoices-logo">
          <a routerLink="/login">
            <img src="assets/images/myunichoices-logo.png" alt="" />
          </a>
        </div>
        <div class="subtitle-strap">
          {{locale.introText}}
        </div>
      </header>

			<!-- Shared base manage password template -->
			<app-base-manage-password [templateSettings]="templateSettings"></app-base-manage-password>

      <footer id="scrn-f">
          <div class="sign-up">
          <a class="cancel_link" href="#" (click)="logout()">{{locale.logoutLinkText}}</a>
          </div>

      </footer>
    </div>
  </div>
</div>





// WEBPACK FOOTER //
// ./src/app/components/account/change-password/change-password.component.html